import { siteTexts } from "../i18n/siteTexts";

const API_BASE = process.env.REACT_APP_API_BASE === "/" ? "" : (process.env.REACT_APP_API_BASE || "http://localhost:3333");

export async function apiRequest<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const { headers: customHeaders, ...restOptions } = options;
  const response = await fetch(`${API_BASE}${path}`, {
    ...restOptions,
    cache: "no-store",
    headers: {
      "Content-Type": "application/json",
      ...(customHeaders || {}),
    },
  });

  if (!response.ok) {
    const text = await response.text();
    let message = text || siteTexts.common.apiError;
    let requestId = response.headers.get("x-request-id") || "";
    try {
      const parsed = JSON.parse(text);
      if (parsed && typeof parsed === "object") {
        const candidate = (parsed as any).error || (parsed as any).message;
        if (typeof candidate === "string" && candidate.trim()) {
          message = candidate.trim();
        }
        const responseRequestId = (parsed as any).requestId;
        if (typeof responseRequestId === "string" && responseRequestId.trim()) {
          requestId = responseRequestId.trim();
        }
      }
    } catch (_err) {
      // Fallback para erros HTML (ex: Express "Cannot PATCH ...")
      const match = String(text || "").match(/<pre>([\s\S]*?)<\/pre>/i);
      if (match && match[1]) {
        const extracted = match[1].replace(/<[^>]+>/g, "").trim();
        if (extracted) message = extracted;
      }
    }
    if (response.status >= 500 && requestId) {
      message = `${message} Código da solicitação: ${requestId}.`;
    }
    throw new Error(message);
  }

  return response.json() as Promise<T>;
}
